import styled from '@emotion/styled'
import { css } from '@emotion/react'

export const menuStyle = () => css`
  label: menu;

  position: absolute;
  right: 0;
  top: 0;
`

export const Menu = styled('div')(menuStyle)

const contentStyle = () => css`
  label: content;

  text-align: center;

  button {
    margin: 0 auto;
  }
`

export const Content = styled('div')(contentStyle)

const dividirStyle = ({ theme }) => css`
  label: divider;

  background: ${theme.colors.n100};
  display: block;
  height: 1px;
  margin: ${theme.spacings.giga} auto;
  max-width: 160px;
  width: 100%;
`

export const Divider = styled('div')(dividirStyle)

export const projectDateStyle = ({ theme }) => css`

  color: ${theme.colors.n600};
  display: block;
  font-size: ${theme.typography.text.kilo.fontSize};
  line-height: ${theme.typography.text.kilo.lineHeight};
`

export const ProjectDate = styled('span')(projectDateStyle)

export const boxStyle = ({ theme }) => css`
  label: box;

  display: flex;
  flex-direction: column;
  justify-content: center;
  margin-top: ${theme.spacings.exa};
  padding-bottom: ${theme.spacings.giga};

  ${theme.media.mega} {
    flex-direction: row;
  }
`

export const Box = styled('div')(boxStyle)

export const boxItemStyle = ({ theme }) => css`
  label: box__item;

  text-align: center;

  &:first-child {
    border-bottom: 1px solid ${theme.colors.n100};
    border-top: 1px solid ${theme.colors.n100};
  }

  &:first-child,
  &:last-child {
    padding: ${theme.spacings.giga} 0;
  }

  ${theme.media.mega} {
    text-align: left;

    &:first-child,
    &:last-child {
      padding: 0 ${theme.spacings.peta};
    }

    &:first-child {
      border: 0;
      border-right: 1px solid ${theme.colors.n100};
    }

    width: calc(100% / 2);
  }

  width: 100%;
`

export const BoxItem = styled('div')(boxItemStyle)

export const boxTitleStyle = ({ theme }) => css`
  label: box__title;

  color: ${theme.colors.n600};
  display: block;
  font-size: ${theme.typography.text.giga.fontSize};
  font-weight: ${theme.font.weight.semibold};
  line-height: ${theme.typography.text.giga.lineHeight};
  margin-bottom: ${theme.spacings.giga};
`

export const BoxTitle = styled('span')(boxTitleStyle)

export const boxTextWeeksNumberStyle = ({ theme }) => css`
  label: box__text;

  background: ${theme.colors.n100};
  border: 1px solid ${theme.colors.n200};
  border-radius: 30px;
  color: ${theme.colors.n600};
  display: inline-block;
  font-size: ${theme.typography.text.kilo.fontSize};
  line-height: ${theme.typography.text.kilo.lineHeight};
  margin-right: ${theme.spacings.byte};
  padding: ${theme.spacings.byte} ${theme.spacings.giga};
  vertical-align: middle;
`

export const BoxTextWeeksNumber = styled('span')(boxTextWeeksNumberStyle)

export const boxTextWeeksStyle = ({ theme }) => css`
    label: box__text--weeks;
    color: ${theme.colors.n800};
    display: inline-block;
    font-size: ${theme.typography.text.mega.fontSize};
    line-height: ${theme.typography.text.mega.lineHeight};
    vertical-align: middle;
`

export const BoxTextWeeks = styled('span')(boxTextWeeksStyle)

export const boxTextInfoStyle = ({ theme }) => css`
  label: box__text--info;

  color: ${theme.colors.n400};
  display: block;
  font-size: ${theme.typography.text.kilo.fontSize};
  line-height: ${theme.typography.text.kilo.lineHeight};
  margin-top: ${theme.spacings.mega};
  padding: 0 ${theme.spacings.tera};

  ${theme.media.mega} {
    padding: 0;
  }
`

export const BoxTextInfo = styled('span')(boxTextInfoStyle)

export const groupStyle = ({ theme }) => css`
  label: group;

  align-items: flex-end;
  display: flex;
  justify-content: center;
  margin-bottom: ${theme.spacings.giga};

  & > div {
    flex: 1 0 0;
    margin-right: ${theme.spacings.mega};
  }

  input {
    margin-bottom: 0;
  }

  button {
    padding: 0 ${theme.spacings.giga};
    width: 100px;
  }

  ${theme.media.mega} {
    justify-content: flex-start;
  }
`

export const Group = styled('div')(groupStyle)

export const formStyle = ({ theme }) => css`
  label: form;

  display: flex;
  flex-direction: column;

  ${Group} {
    &:not(:last-child) {
      margin-bottom: ${theme.spacings.mega};
    }
  }
`

export const Form = styled('form')(formStyle)

export const messageHelperStyle = ({ theme }) => css`
    label: message__helper;

    color: ${theme.colors.n200};
    display: block;
    font-size: ${theme.typography.text.kilo.fontSize};
    font-style: italic;
    line-height: ${theme.typography.text.kilo.lineHeight};
    text-align: left;
`

export const MessageHelper = styled('div')(messageHelperStyle)

export const projectFooterStyle = ({ theme }) => css`
  label: project__footer;

  margin-top: ${theme.spacings.giga};
`

export const ProjectFooter = styled('div')(projectFooterStyle)
